var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroBgMob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 977,
    viewBox: "0 0 390 977",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_453_1797)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 813,
    x2: 16,
    y2: 4,
    stroke: "white",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 116,
    y1: 713,
    x2: 116,
    y2: 64,
    stroke: "white",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 188,
    y1: 713,
    x2: 188,
    y2: 64,
    stroke: "white",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 260,
    y1: 713,
    x2: 260,
    y2: 64,
    stroke: "white",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 332,
    y1: 713,
    x2: 332,
    y2: 64,
    stroke: "white",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116 65.5L-115.5 -74",
    stroke: "white",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116 136.5L-125.5 17.5",
    stroke: "white",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116 208.5L-122 109",
    stroke: "white",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116 280.5L-122 210",
    stroke: "white",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116 352.5H-122.5",
    stroke: "white",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-124.5 956.5L115.5 718",
    stroke: "white",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-133 838L115.5 646",
    stroke: "white",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-116.5 719L115.5 569",
    stroke: "white",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-125 617L115.5 497",
    stroke: "white",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-125.5 497.5L115.5 425",
    stroke: "white",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 963.5L188.5 718",
    stroke: "white",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.5 959L260.5 718",
    stroke: "white",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.5 972L332 718",
    stroke: "white",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.5 959L403.5 718",
    stroke: "white",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341 972L475 718",
    stroke: "white",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188 65.5L11 -74",
    stroke: "white",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.5 65.5L124.5 -73",
    stroke: "white",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.5 65.5L202.5 -73",
    stroke: "white",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.5 65.5L317.5 -76",
    stroke: "white",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 116.5,
    y1: 64.5,
    x2: 1080.5,
    y2: 64.5,
    stroke: "white",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.5,
    y1: 4.5,
    x2: 1178.5,
    y2: 4.5001,
    stroke: "white",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 116.5,
    y1: 136.5,
    x2: 1080.5,
    y2: 136.5,
    stroke: "white",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 116.5,
    y1: 208.5,
    x2: 1080.5,
    y2: 208.5,
    stroke: "white",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 116.5,
    y1: 280.5,
    x2: 1080.5,
    y2: 280.5,
    stroke: "white",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 116.5,
    y1: 352.5,
    x2: 1080.5,
    y2: 352.5,
    stroke: "white",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 116.5,
    y1: 424.5,
    x2: 1080.5,
    y2: 424.5,
    stroke: "white",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 116.5,
    y1: 496.5,
    x2: 1080.5,
    y2: 496.5,
    stroke: "white",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 116.5,
    y1: 568.5,
    x2: 1080.5,
    y2: 568.5,
    stroke: "white",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 116.5,
    y1: 640.5,
    x2: 1080.5,
    y2: 640.5,
    stroke: "white",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 116.5,
    y1: 712.5,
    x2: 1080.5,
    y2: 712.5,
    stroke: "white",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.5,
    y1: 812.5,
    x2: 1180.5,
    y2: 812.5,
    stroke: "white",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: -85.5,
    y1: 912.5,
    x2: 1280.5,
    y2: 912.5,
    stroke: "white",
    strokeOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_453_1797"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 390,
    height: 977,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroBgMob);
export default __webpack_public_path__ + "static/media/Hero- BG Mob.d1a0c19003ccbcedef28d63a10f04f6e.svg";
export { ForwardRef as ReactComponent };